import React, { useState, useEffect } from "react";
import { AiOutlineSave } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TextField, Snackbar, Alert } from "@mui/material";
import * as api from "../api/api";
import Spinner from "react-bootstrap/Spinner";
import Loading from "./Loading";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

function TeamInfo(props) {
  const { language } = useLanguage();
  const pageTitle = "TeamInfo";
  const [isEditing, setIsEditing] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setLoading] = useState(false);
  const { handleRemoveTeam, addTeamButton, onTeamInfoChange } = props;
  const [teamInfo, setTeamInfo] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [oldTeamName, setOldTeamName] = useState("");
  const [snackbar, setSnackbar] = useState({
    state: false,
    message: "",
    status: { success: "success", error: "error" },
  });
  const { team } = props;

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ state: false });
  };

  const handleEdit = () => {
    setOldTeamName(teamInfo.name);
    setEditMode(true);
    addTeamButton(true);
  };
  const handleSaveEdit = () => {
    setLoading(true);
    setIsEditing(true);
    if (teamInfo.name === "") {
      setLoading(false);
      setIsEditing(false);
      console.log("ana hena");
      setSnackbar({
        status: "error",
        state: true,
        message: strings[pageTitle][language].cannotBeEmpty,
      });
      return;
    }
    if (teamInfo.teamId) {
      api.updateTeamById(teamInfo.teamId, teamInfo).then((res) => {
        if (res.data.statusCode !== "400") {
          setSnackbar({
            state: true,
            message: res.data.message,
            status: "success",
          });
        } else {
          setSnackbar({
            state: true,
            message: res.data.message,
            status: "error",
          });

          setTeamInfo({ name: oldTeamName, teamId: teamInfo.teamId });
        }
        setLoading(false);
        setIsEditing(false);
        setEditMode(false);
        addTeamButton(false);
      });
    } else {
      //to be changed later when we can only use the name of team without other attributes
      let newTeam = {
        ...teamInfo,
        tenantId: JSON.parse(sessionStorage.getItem("userTenant")).tenantId,
        createdByUserId: 78910,
        modifiedByUserId: 112131,
      };
      setLoading(true);
      api.insertTeam(newTeam).then((res) => {
        console.log(res.data.object);
        if (res.data.statusCode !== "400") {
          setSnackbar({
            state: true,
            message: res.data.message,
            status: "success",
          });

          setTeamInfo((prevTeamInfo) => {
            const updatedTeamInfo = res.data.object;
            onTeamInfoChange(updatedTeamInfo);
            return updatedTeamInfo;
          });

          let placeholder = res.data.object;
          console.log(placeholder);
        } else {
          setSnackbar({
            state: true,
            message: res.data.message,
            status: "error",
          });
          setTeamInfo((prevTeamInfo) => ({
            ...prevTeamInfo,
            name: oldTeamName,
          }));
        }
        setLoading(false);
        setIsEditing(false);
        setEditMode(false);
        addTeamButton(false);
      });
    }
  };

  const handleDeleteTeam = (id) => {
    setLoading(true);
    console.log("DOES IT GET AN IMPROPER ID? : ", id);
    api.deleteTeamById(id).then(() => {
      handleRemoveTeam(id);
      setLoading(false);
      setIsEditing(false);
      setEditMode(false);
      setShow(false);
      console.log("deleted");
    });
  };

  const handleCancel = () => {
    if (teamInfo.teamId) {
      setTeamInfo({
        ...teamInfo,
        name: oldTeamName,
      });
      setEditMode(false);
      addTeamButton(false);
    } else {
      // TODO : remove the team from the list
      handleRemoveTeam(teamInfo.teamId);
      addTeamButton(false);
    }
  };
  const handleNameChange = (e) => {
    setTeamInfo({
      ...teamInfo,
      name: e.target.value,
    });
    addTeamButton(true);
  };

  useEffect(() => {
    setTeamInfo(team);
  }, [team]);

  useEffect(() => {
    if (teamInfo.teamId === "") {
      setEditMode(true);
    }
  }, [teamInfo]);

  return (
    <div className="team-info">
      {isLoading && <Loading />}
      {editMode ? (
        <>
          <div className="team-info__name">
            <TextField
              id="outlined-basic"
              label={strings[pageTitle][language].label}
              variant="outlined"
              size="small"
              value={teamInfo.name}
              onChange={handleNameChange}
            />
          </div>
          <div className="team-info__buttons">
            <button className="button-with-icon" onClick={handleSaveEdit}>
              {!isEditing ? (
                <AiOutlineSave />
              ) : (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
            <button className="button-with-icon" onClick={handleCancel}>
              <RxCross2 />
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="team-info__name">{teamInfo.name}</div>
          <div className="team-info__buttons">
            <button
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "rgba(255, 0, 0, 0)",
                color: "#00a0e5",
              }}
              className="icon-btn"
              onClick={handleEdit}
            >
              <EditIcon />
            </button>
            <button
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "rgba(255, 0, 0, 0)",
                color: "#00a0e5",
              }}
              className="icon-btn"
              onClick={() => {
                setShow(true);
              }}
            >
              <DeleteIcon />
            </button>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].deleteModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{strings[pageTitle][language].deleteModalBody}</Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="danger"
            onClick={() => handleDeleteTeam(teamInfo.teamId)}
          >
            {strings[pageTitle][language].delete}
          </Button>
        </Modal.Footer>
      </Modal>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.state}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.status}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default TeamInfo;
